import { createSlice, ThunkAction, Action } from '@reduxjs/toolkit';
import { RootState } from './index';

export interface StoreAlertsState {
  news: Array<StoreAlert>;
  viewed: Array<StoreAlert>;
}

export interface StoreAlert {
  id: string;
  type: 'danger' | 'success' | 'warning' | 'info';
  text: string;
  timeout?: number;
}

const initialState: StoreAlertsState = {
  news: [],
  viewed: []
};

const slice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    errorAlert: (state, action) => {
      state.news.push({ type: 'danger', text: action.payload, id: genId() });
    },
    successAlert: (state, action) => {
      state.news.push({ type: 'success', text: action.payload, id: genId() });
    },
    warningAlert: (state, action) => {
      state.news.push({ type: 'warning', text: action.payload, id: genId() });
    },
    infoAlert: (state, action) => {
      state.news.push({ type: 'info', text: action.payload, id: genId() });
    },
    removeAlert: (state, action) => {
      state.viewed.push(state.news.find((notif) => notif.id !== action.payload));
      state.news = state.news.filter((notif) => notif.id !== action.payload);
    },
    clearAlerts: (state, action) => {
      state.viewed = [...state.viewed, ...state.news]
      state.news = [];
    }
  },
});

const genId = () => Date.now().toString();

export const { clearAlerts, removeAlert, errorAlert, successAlert, warningAlert, infoAlert } = slice.actions;

export const getAlerts = (state: RootState) => state.alerts.news;

export const clearAlertsAsync = (amount: number): ThunkAction<void, RootState, unknown, Action<string>> => dispatch => {
  setTimeout(() => {
    dispatch(clearAlerts(amount));
  }, amount);
};

export default slice.reducer;
